exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.page-block-children .block.docx-heading1-block {\n  margin-top: 26px;\n  margin-bottom: 10px;\n  font-size: 26px;\n}\n.block.docx-heading1-block .el-icon-caret-bottom{\n  display: none;\n}\n.listitem:hover .block.docx-heading1-block .el-icon-caret-bottom{\n  display: inline-block;\n}\n", ""]);

// exports
